const WasyuProductCategories = ['赤ワイン', '白ワイン', 'ロゼワイン', 'スパークリングワイン', 'オレンジワイン', 'シードル/ポワレ', 'その他ワイン', 'ブランデー', 'ノンアルコール', 'ジュース', 'その他ソフトドリンク', '日本酒', 'フード', '雑貨', 'ギフト パッケージ' ];
const searchTagList = ['関連キーワード_新着','関連キーワード_予約','関連キーワード_再入荷','関連キーワード_限定','関連キーワード_受賞ワイン','関連キーワード_セール','関連キーワード_再値下げ','関連キーワード_送料無料'];
function searchanizeProcess() {
  return new Promise(async function(resolve, reject) {
    const extractProductId = function (r) { return r.getAttribute("id").replace(/^.*-([^-]+)$/, "$1"); };
    const extractProductHandle = function (h) { return (h.getAttribute("href").split('/')).pop(); }
    async function getProductObject(handle) {
      handle = (handle.split('?'))[0];
      return new Promise(async(resolve,reject)=>{
        try { await $.getJSON(`/products/${handle}.js`,function(product) { return resolve(product); });
        } catch (error) { return resolve({id:''}); }
      });
    }
    await $(document).on("Searchanise.ResultsUpdated", async function (ev, $results) {

      const viewportWidth = screen.width; 
      const prevCollectionLinkPc = document.querySelector('.product-list__all-collection-pc');
      const prevCollectionLinkSp = document.querySelector('.product-list__all-collection-sp');
      const pcFiltersDiv = document.querySelector('.snize-filters-sidebar');
      const spFiltersDiv = document.querySelector('.snize-product-filters-buttons-container');
      const pcAllCollectionLink = `<a class="product-list__all-collection-pc" href="/collections/all"><div id="snize_filters_block_stock_status" class="snize-product-filters-block" style="display: block"><div class="snize-product-filters-title" style="margin-left: 20px"><span>全てのアイテム</span></div></div></a>`;
      const spAllCollectionLink = `<a class="product-list__all-collection-sp" href="/collections/all"><button class="snize-product-filters-show-products">全てのアイテム</button></a>`;

      if (!prevCollectionLinkPc) {

        if (pcFiltersDiv) {
          pcFiltersDiv.insertAdjacentHTML('afterbegin', pcAllCollectionLink);
        }

      };

      if (!prevCollectionLinkSp) {

        if (spFiltersDiv) {
          spFiltersDiv.insertAdjacentHTML('beforeend', spAllCollectionLink);
        }

      };
      

      let productIds = [];
      await $results.find(".snize-product").each(function () { productIds.push(extractProductId(this)); });
      let productHandles = [];
      await $results.find(".snize-view-link").each(function () { extractProductHandle(this); productHandles.push(extractProductHandle(this));});
      let productArray = [];
      for (let i = 0; i < productHandles.length; i++) {
        const productObject = await getProductObject(productHandles[i]);
        productArray.push(productObject);
      }
      await $results.find(".snize-product").each(async function () {
        const searchProduct = productArray.filter(p => p.id == extractProductId(this));
        if (searchProduct.length > 0) {

          const productObjectData = searchProduct[0];
          const $itemHeader = $(this).find(".snize-custom-item-header").empty();
          let category = '';
          let catchPhrase = '';
          let tasteText = '';
          let tasteBody = '';
          let prefecture = '';

/*           const favButtonDiv = $(this).find('._SFA.collection');
          const favButton = $(this).find('.SFA__btn__list');
          $(this).find(".snize-custom-item-header").append(favButtonDiv);
          $(favButton).css('display', 'block'); */

          if (productObjectData.tags && 0 < productObjectData.tags.length) {
            const $ul = $('<ul class="tag_wrap p_tag_wrap txt_pankuzu mb_s2"></ul>').appendTo($itemHeader);
// ++ 符 committed on 2021/09/01 for PJ_WASYU-77
//               searchTagList.forEach((stag, index) => {
//                 if(productObjectData.tags.includes(stag)) {
//                   const $li = $("<li />").addClass(stag).appendTo($ul);
//                   $li.text(stag == "受賞ワイン" ? "受賞": stag);
//                 }
//               })
              var isMobile = navigator.userAgent.match(/(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini|Windows Phone)/i);
		      var j = 0;
              var k = 0;

              if(isMobile){
                  k = 4
              }else{
                  k = 1000
              }

              for (var i=0; i<searchTagList.length && j<k; i++)
                { 
                  if(productObjectData.tags.includes(searchTagList[i])) {
                    const $li = $("<li />").addClass(searchTagList[i].replace('関連キーワード_','')).appendTo($ul);
                    $li.text(searchTagList[i] == "関連キーワード_受賞ワイン" ? "受賞": searchTagList[i].replace("関連キーワード_", ""));
  				  j++;
                  }
                }
// -- 符 committed on 2021/09/01 for PJ_WASYU-77

            productObjectData.tags.forEach(function (tag) {
              // if (searchTagList.indexOf(tag) !== -1) {
              //   const $li = $("<li />").appendTo($ul);
              //   $li.text(ttag); 
              // }
              if (tag.includes('都道府県_')) { prefecture = tag.replace('都道府県_',''); }
              if (tag.includes('meta-ProductType2:')) { category = tag.replace('meta-ProductType2:',''); }
              if (tag.includes('meta-CatchPhrase:')) { catchPhrase = tag.replace('meta-CatchPhrase:',''); }
              if (tag.includes('meta-TasteText:')) { tasteText = tag.replace('meta-TasteText:',''); }
              if (tag.includes('meta-Body:')) { tasteBody = tag.replace('meta-Body:',''); }
            });
          }
          const $paragraphForCategoryAndTaste = $('<p class="mb_s1 snize-sp-upperfont" />').appendTo($itemHeader);
          const $span = $('<span class="bold pr_10 product-type2" />').appendTo($paragraphForCategoryAndTaste);
          if (category === "シードル" || category === "ポワレ") {$(this).find(".snize-thumbnail-wrapper").addClass("シードル／ポワレ");
          } else { $(this).find(".snize-thumbnail-wrapper").addClass(category);}
          $(this).find(".product-type2").text(category);
          $('<br class="sp_only" />').appendTo($paragraphForCategoryAndTaste);
          const tasteBodyAndTextLength = tasteBody.length + tasteText.length;
          const $spans = $(`<span class="pr_10 tastebody">${tasteBody}</span><span class="pr_10 taste_slash"></span>${viewportWidth < 340 && tasteBodyAndTextLength > 11 ? '<br class="sp_only" />' : ''}<span class="pr_10 tastetext">${tasteText}</span>`).appendTo(
            $paragraphForCategoryAndTaste
          );
          if (tasteBody !== '' && tasteText !== '') { $(this).find(".taste_slash").text('/'); }
          if (productObjectData.vendor && productObjectData.vendor != "wa-syu") {
            const wineryLength = productObjectData.vendor.length;
            const lineBreakMargin = wineryLength > 7 ? `class="prefecture-margin"` : ``;
            const prefectureLineBreak = wineryLength > 7 ? `<br class="sp-only">` : ``;
            const prefectureString = prefecture ? `<span class="pr_10">/</span>${prefectureLineBreak}<span ${lineBreakMargin}>${prefecture}</span>` : ``;
            const $p = $('<p class="mb_s2 snize-sp-upperfont" />').appendTo($itemHeader);
            $p.html(`<span class="pr_10">${productObjectData.vendor}</span>${prefectureString}`);
          }
          $(this).find("div.snize-price-list").empty();
          if (productObjectData.compare_at_price === null) {
            $(this).find("div.snize-price-list").html(`<span class="snize-price money">¥${String(productObjectData.price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>`);
          } else {
            $(this).find("div.snize-price-list").html(`<span class="snize-discounted-price money">¥${String(productObjectData.compare_at_price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span><span class="snize-price snize-price-with-discount money">¥${String(productObjectData.price / 100).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,')}</span>`);
          }
          $(this).find(".snize-description>p").addClass('').empty().text(catchPhrase);
          $('div.snize-options-box').remove();
          $(`#snize-product-${extractProductId(this)}`).css('display', '');
          $(this).find(".snize-thumbnail>img").addClass('howatto-hover');
          $(this).find(".snize-thumbnail").addClass('howatto-hover');
          if (productObjectData.available === false) {
            $(this).find(".snize-thumbnail").addClass('list_item_img_soldout');
            $(this).find(".snize-thumbnail").css('opacity', '0.5');
          }
          if (productObjectData.images.length > 1) {
            $(this).find(".snize-thumbnail>img").attr('src',productObjectData.images[1]);
          }

          
        }
      });
    });
    return resolve(true);
  });
}
searchanizeProcess();